import { createClient } from '@supabase/supabase-js';

const supabaseUrl = String(process.env.REACT_APP_SUPABASE_URL || '').trim();
const supabasePublishableKey = String(
  process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY || process.env.REACT_APP_SUPABASE_ANON_KEY || ''
).trim();

export const isAccountAuthConfigured = Boolean(supabaseUrl && supabasePublishableKey);

export const supabase = isAccountAuthConfigured
  ? createClient(supabaseUrl, supabasePublishableKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null;
